var map = {
	"./academy-course-illustration1.png": "b824",
	"./academy-course-illustration2.png": "8396",
	"./app-academy-tutor-1.png": "09b2",
	"./app-academy-tutor-2.png": "8574",
	"./app-academy-tutor-3.png": "d052",
	"./app-academy-tutor-4.png": "8a81",
	"./app-academy-tutor-5.jpg": "28eb",
	"./app-academy-tutor-5.png": "65db",
	"./app-academy-tutor-6.png": "d7e8",
	"./onboarding.png": "dd65"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "da20";